import { render } from "./Spinner.vue?vue&type=template&id=b84f48f2&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=b84f48f2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84f48f2"]])

export default __exports__